import { STEP_STATE } from '@angular/cdk/stepper';
import { AfterContentInit, Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { ClientMeasure } from 'src/app/domain/client-measure';
import { FDXMeasureCategory } from 'src/app/domain/enum/fdx-measure-category';
import { EMeasureCategory } from 'src/app/domain/enum/measure-category';
import { EStrategyStatus } from 'src/app/domain/enum/strategy-status';
import { EZoneUsage } from 'src/app/domain/enum/zone-usage';
import { Strategy } from 'src/app/domain/strategy';
import { EStrategyType } from 'src/app/domain/strategy-type';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { ClientMeasureService } from 'src/app/services/client-measure.service';
import { DocumentService } from 'src/app/services/document.service';
import { StrategyService } from 'src/app/services/strategy.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { BaseComponent } from '../base/base.component';
import { EMeasureParentType } from 'src/app/domain/enum/measure-parent-type';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelectionCategoryBoxDialog } from 'src/app/tools/ui/selection-category-synthese-chantier/selection-category-synthese-chantier-box';
import { MatDialog } from '@angular/material/dialog';
import { OptionForSynthese } from 'src/app/tools/ui/selection-category-synthese-chantier/option-for-synthese';

@Component({
    selector: 'app-strategy-detail',
    templateUrl: './strategy-detail.component.html',
    styleUrls: ['./strategy-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StrategyDetailComponent extends BaseComponent implements OnInit, AfterContentInit {

    toPlanDisplayedColumns = ['measure', 'name'];
    displayedColumns = this.toPlanDisplayedColumns;
    plannedDisplayedColumns = ['measure', 'name', 'battery', 'express', 'samplingDate', 'actions'];
    finishedDisplayedColumns = ['measure', 'name', 'battery', 'express', 'samplingDate', 'sa', 'nbfiber', 'concentration', 'actions'];
    exoticDisplayedColumns = ['name', 'description', 'date', 'result', 'actions'];
    SelectedList: number = 1;
    Strategy: Strategy;
    OrderedMeasureList: ClientMeasure[] = [];
    OrderableMeasureList: ClientMeasure[] = [];
    AnalysedMeasureList: ClientMeasure[] = [];
    FilteredOrderedMeasureList: ClientMeasure[] = [];
    FilteredOrderableMeasureList: ClientMeasure[] = [];
    FilteredAnalysedMeasureList: ClientMeasure[] = [];

    UsageList: string[] = Object.values(EZoneUsage).filter(x => !isNaN(Number(x))).map(x => StringConverter.getZoneUsageName(x as EZoneUsage));
    SelectedUsage: EZoneUsage | number;

    AvailableZoneAndProcessList: ClientMeasure[] = [];
    SelectedZoneOrProcess: (ClientMeasure | number)[] = [];

    get IsFDX() {
        if (this.Strategy.Type === EStrategyType.FDX) {
            return true;
        }

        return false;
    }

    constructor(
        private snackBar: MatSnackBar,
        protected coreData: CoreData,
        private route: ActivatedRoute,
        private router: Router,
        private strategyService: StrategyService,
        private clientMeasureService: ClientMeasureService,
        private documentService: DocumentService,
        private dialog: MatDialog
    ) {
        super(coreData);
    }

    ngOnInit(): void {

    }

    ngAfterContentInit(): void {
        this.strategyService.getStrategyById(this.route.snapshot.params['id']).subscribe(x => {
            this.Strategy = x;
        });

        this.clientMeasureService.getOrderableMeasureList(this.route.snapshot.params['id']).subscribe(x => {
            this.OrderableMeasureList = x;
            this.FilteredOrderableMeasureList = x;
            this.FilteredOrderableMeasureList = _.orderBy(this.FilteredOrderableMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');
            // this.AvailableZoneAndProcessList.push(..._.uniq(x.map(y => y.ParentName)));
            // this.SelectedList = 1;
        });

        this.clientMeasureService.getOrderedMeasureList(this.route.snapshot.params['id']).subscribe(x => {
            this.AnalysedMeasureList = x.filter(y => y.ELIMSResult);
            this.FilteredAnalysedMeasureList = this.AnalysedMeasureList;
            this.FilteredAnalysedMeasureList = _.orderBy(this.FilteredAnalysedMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');

            this.OrderedMeasureList = x.filter(y => !y.ELIMSResult);
            this.FilteredOrderedMeasureList = this.OrderedMeasureList;
            this.FilteredOrderedMeasureList = _.orderBy(this.FilteredOrderedMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');

        });
    }

    changeDisplayMode(type: number) {
        this.SelectedList = type;

        this.SelectedUsage = null;
        this.getZoneOrProcessAvailable();
    }

    // public isStepDone(id: number) {
    //   if (!this.Strategy) {
    //     return false;
    //   }
    //   switch (this.Strategy?.Status) {
    //     case EStrategyStatus.Ordered:
    //       if (id > 1)
    //         return true;
    //     case EStrategyStatus.New:
    //     case EStrategyStatus.WorkMeasurementMPCA:
    //     case EStrategyStatus.ZoneProcess:
    //       if (id > 2) {
    //         return true;
    //       }
    //       break;
    //     case EStrategyStatus.Proposal:
    //       if (id > 3) {
    //         return true;
    //       }
    //       break;
    //     case EStrategyStatus.WorkInProgress:
    //       if (id > 4) {
    //         return true;
    //       }
    //       break;
    //     case EStrategyStatus.FinalReportTBD:
    //       if (id > 5) {
    //         return true;
    //       }
    //       break;
    //     case EStrategyStatus.FinalReport:
    //       if (id > 6) {
    //         return true;
    //       }
    //   }

    //   return false;
    // }

    refreshAvailableZoneAndProcessList() {
        this.AvailableZoneAndProcessList = [];
        this.SelectedZoneOrProcess = [];

        this.FilteredOrderableMeasureList = [];
        this.FilteredOrderedMeasureList = [];
        this.FilteredAnalysedMeasureList = [];
        switch (this.SelectedList) {
            case 1:
                this.AvailableZoneAndProcessList.push(..._.uniqBy(this.OrderableMeasureList, x => { return x.ParentName }));
                break;
            case 2:
                this.AvailableZoneAndProcessList.push(..._.uniqBy(this.OrderedMeasureList, x => { return x.ParentName }));
                break;
            case 3:
                this.AvailableZoneAndProcessList.push(..._.uniqBy(this.AnalysedMeasureList, x => { return x.ParentName }));
                break;

        }
    }

    getZoneOrProcessAvailable() {
        this.refreshAvailableZoneAndProcessList();

        this.AvailableZoneAndProcessList = _.uniqBy(this.AvailableZoneAndProcessList.filter(x => this.SelectedUsage === 1337 ? x.IsComplementary : x.ZoneUsage === this.SelectedUsage && !x.IsComplementary), y => y.ParentName);

        // this.AvailableZoneAndProcessList.push(..._.uniqBy(this.AvailableZoneAndProcessList.filter(x => x.IsComplementary === true), y => y.ParentName))
        // switch (this.SelectedList) {
        //     case 1:
        //         this.SelectedZoneOrProcess = this.OrderableMeasureList.filter(x => x.ZoneUsage === this.SelectedUsage);
        //         break;
        //     case 2:
        //         this.SelectedZoneOrProcess = this.OrderedMeasureList.filter(x => x.ZoneUsage === this.SelectedUsage);
        //         break;
        //     case 3:
        //         this.SelectedZoneOrProcess = this.AnalysedMeasureList.filter(x => x.ZoneUsage === this.SelectedUsage);
        //         break;
        // }
        this.getMeasuresAvailable();
    }

    getMeasuresAvailable() {
        // Click on ALL
        if (this.SelectedZoneOrProcess.find(x => x === this.ALL)) {
            this.FilteredOrderableMeasureList = this.OrderableMeasureList.filter(x => x.ZoneUsage === this.SelectedUsage && !x.IsComplementary);
            this.FilteredOrderedMeasureList = this.OrderedMeasureList.filter(x => x.ZoneUsage === this.SelectedUsage && !x.IsComplementary);
            this.FilteredAnalysedMeasureList = this.AnalysedMeasureList.filter(x => x.ZoneUsage === this.SelectedUsage && !x.IsComplementary)

            if (this.SelectedUsage === 1337) { // Complementary

                this.FilteredOrderableMeasureList = this.OrderableMeasureList.filter(x => x.IsComplementary);
                this.FilteredOrderedMeasureList = this.OrderedMeasureList.filter(x => x.IsComplementary);
                this.FilteredAnalysedMeasureList = this.AnalysedMeasureList.filter(x => x.IsComplementary)
            }
        }

        else {
            if (this.SelectedZoneOrProcess.length) {

                if (this.SelectedUsage === 1337) { // Complementary
                    this.FilteredOrderableMeasureList = this.OrderableMeasureList.filter(x => x.IsComplementary && _.includes((this.SelectedZoneOrProcess as ClientMeasure[]).map(y => y.ParentName), x.ParentName));
                    this.FilteredOrderedMeasureList = this.OrderedMeasureList.filter(x => x.IsComplementary && _.includes((this.SelectedZoneOrProcess as ClientMeasure[]).map(y => y.ParentName), x.ParentName));
                    this.FilteredAnalysedMeasureList = this.AnalysedMeasureList.filter(x => x.IsComplementary && _.includes((this.SelectedZoneOrProcess as ClientMeasure[]).map(y => y.ParentName), x.ParentName))
                } else {
                    this.FilteredOrderedMeasureList = this.OrderedMeasureList.filter(x => !x.IsComplementary && _.includes((this.SelectedZoneOrProcess as ClientMeasure[]).map(y => y.ParentName), x.ParentName) && x.ZoneUsage === this.SelectedUsage);
                    this.FilteredOrderableMeasureList = this.OrderableMeasureList.filter(x => !x.IsComplementary && _.includes((this.SelectedZoneOrProcess as ClientMeasure[]).map(y => y.ParentName), x.ParentName) && x.ZoneUsage === this.SelectedUsage);
                    this.FilteredAnalysedMeasureList = this.AnalysedMeasureList.filter(x => !x.IsComplementary && _.includes((this.SelectedZoneOrProcess as ClientMeasure[]).map(y => y.ParentName), x.ParentName) && x.ZoneUsage === this.SelectedUsage);
                }
            }
            else {
                this.FilteredOrderableMeasureList = this.OrderableMeasureList;
                this.FilteredOrderedMeasureList = this.OrderedMeasureList;
                this.FilteredAnalysedMeasureList = this.AnalysedMeasureList;
            }
        }
        // } else if (!this.SelectedUsage) {
        //     this.FilteredOrderableMeasureList = this.OrderableMeasureList;
        //     this.FilteredOrderedMeasureList = this.OrderedMeasureList;
        //     this.FilteredAnalysedMeasureList = this.AnalysedMeasureList;
        // } else {
        //     this.FilteredOrderableMeasureList = [];
        //     this.FilteredOrderedMeasureList = [];
        //     this.FilteredAnalysedMeasureList = [];
        // }

        this.FilteredOrderableMeasureList = _.orderBy(this.FilteredOrderableMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');
        this.FilteredOrderedMeasureList = _.orderBy(this.FilteredOrderedMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');
        this.FilteredAnalysedMeasureList = _.orderBy(this.FilteredAnalysedMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');
    }

    getProposition() {
        this.documentService.getPropositionReport(this.Strategy.Id).subscribe(x => {
            this.promptFile(x);
        });
    }

    getFinalRapport() {
        this.documentService.getFinalReport(this.Strategy.Id).subscribe(x => {
            this.promptFile(x);
        });
    }

    getUsageCounter(usage: EZoneUsage | number) {
        switch (this.SelectedList) {
            case 1:
                return usage === 1337 ? _.filter(this.OrderableMeasureList, x => x.IsComplementary).length : _.filter(this.OrderableMeasureList, x => x.ZoneUsage === usage && !x.IsComplementary).length;
            case 2:
                return usage === 1337 ? _.filter(this.OrderedMeasureList, x => x.IsComplementary).length : _.filter(this.OrderedMeasureList, x => x.ZoneUsage === usage && !x.IsComplementary).length;
            case 3:
                return usage === 1337 ? _.filter(this.AnalysedMeasureList, x => x.IsComplementary).length : _.filter(this.AnalysedMeasureList, x => x.ZoneUsage === usage && !x.IsComplementary).length;
        }
    }

    getDataSource() {
        switch (this.SelectedList) {
            case 1:
                this.displayedColumns = this.toPlanDisplayedColumns
                return this.FilteredOrderableMeasureList
            //return _.orderBy(this.OrderableMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');
            case 2:
                this.displayedColumns = this.plannedDisplayedColumns
                return this.FilteredOrderedMeasureList
            // return _.orderBy(this.OrderedMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');
            case 3:
                this.displayedColumns = this.finishedDisplayedColumns
                return this.FilteredAnalysedMeasureList.filter(x => x.ParentType === EMeasureParentType.Zone || x.ParentType === EMeasureParentType.Process)
            // return _.orderBy(this.AnalysedMeasureList, [(o) => { return o.SamplingDate || '' }, (o) => { return o.ParentName || '' }], 'desc');
        }
    }

    HasExotic() {
        return this.getExoticSource().length > 0;
    }

    getExoticSource() {
        return this.FilteredAnalysedMeasureList.filter(x => x.ParentType !== EMeasureParentType.Zone && x.ParentType !== EMeasureParentType.Process)
    }

    getMapFile(samplingId: number) {
        this.documentService.getAreaMapFileBySampingId(samplingId).subscribe(x => {

            this.promptFile(x);
        });
    }

    getELIMSReport(samplingId: number) {
        this.documentService.getElimsReport(samplingId).subscribe(x => {
            this.promptFile(x);
        });
    }

    getReportListForStrategy() {
        this.documentService.getReportListForStrategy(this.Strategy.Id).subscribe(x => {
            this.promptFile(x);
        });
    }

    getSyntheseChantier(options: OptionForSynthese) {
        this.documentService.getSyntheseChantier(this.Strategy.Id, options).subscribe(x => {
            this.promptFile(x);
        });
    }

    CanBeReOrder(element: ClientMeasure) {
        if (this.IsFDX) {
            return element.Category !== FDXMeasureCategory.PreliminaryWork &&
                element.Category !== FDXMeasureCategory.DuringWorkOperator &&
                element.Category !== FDXMeasureCategory.DuringWorkEnvironmental &&
                element.Category !== FDXMeasureCategory.PostWork
        }

        return element.Category !== EMeasureCategory.PreliminaryWork &&
            element.Category !== EMeasureCategory.DuringWorkOperator &&
            element.Category !== EMeasureCategory.DuringWorkEnvironmental
    }

    reOrderZone(cm: ClientMeasure) {
        this.clientMeasureService.preOrderSampling(cm.SamplingId).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Cette zone est devenue recommandable !', this.snackBar)
                // GO TO ORDER
                this.navigateToOrder(cm)
            }
        })
    }

    getStepFromStrategyStatus() {
        switch (this.Strategy.Status) {
            case EStrategyStatus.Ordered:
                return 1;
            case EStrategyStatus.New:
            case EStrategyStatus.WorkMeasurementMPCA:
            case EStrategyStatus.ZoneProcess:
                return 2;
            case EStrategyStatus.Proposal:
                return 3;
            case EStrategyStatus.WorkInProgress:
            case EStrategyStatus.FinalReportTBD:
                return 4;
            case EStrategyStatus.FinalReport:
                return 5;
        }
    }


    openSelectionCategoryForSyntheseChantier() {
        const dialogRef = this.dialog.open(SelectionCategoryBoxDialog, {
            data: {  },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: OptionForSynthese) => {
            if (result) {
                this.getSyntheseChantier(result)
            }
        });
    }

    navigateToOrder(cm: ClientMeasure) {
        this.router.navigate([ENavigationRoute.Order, { id: this.Strategy.Id, measureId: cm.SamplingId }]);
    }

    navigateToAgency() {
        this.router.navigate([ENavigationRoute.Agency, { id: this.Strategy.Id }]);
    }

    getResultExport(strategy: Strategy) {
        this.documentService.getResultExport(strategy.Id).subscribe(x => {
            this.promptFile(x);
        })
    }

    public compareWith(m1: ClientMeasure, m2: ClientMeasure) {
        return m1 && m2 ? m1.ParentName === m2.ParentName : m1 === m2;
    }
}
